const REQUEST_TEAM_STORY = '@@team_stories/REQUEST_TEAM_STORY';
const TEAM_STORY_RESPONSE = '@@team_stories/TEAM_STORY_RESPONSE';
const REQUEST_TEAM_STORY_DETAIL = '@@team_stories/REQUEST_TEAM_STORY_DETAIL';
const TEAM_STORY_DETAIL_RESPONSE = '@@team_stories/TEAM_STORY_DETAIL_RESPONSE';

export default {
	REQUEST_TEAM_STORY,
	TEAM_STORY_RESPONSE,
	REQUEST_TEAM_STORY_DETAIL,
	TEAM_STORY_DETAIL_RESPONSE,
};
